import { UTCDate } from '@date-fns/utc';
import { format } from 'date-fns';
import { registry } from '../validations/registry';
export function getFromRegistry(field) {
    return registry.get(field)?.label ?? '';
}
export function asFieldData(data) {
    if (!data) {
        return undefined;
    }
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [
        key,
        value == null ? undefined : value,
    ]));
}
export function formatReadOnlyDate(date) {
    return format(new UTCDate(date), 'MMM dd, yyyy');
}
